import styled from 'styled-components';
import { useThemeComponents } from '../themes';

const Container = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const LoadingElement = () => {
    const { LoadingSpinner } = useThemeComponents();

    return (
        <Container>
            <LoadingSpinner />
        </Container>
    );
};

export default LoadingElement;
